<template>
    <div class="main-container page-container">
        <div class="tab-box">
            <div
                class="tab-item"
                :class="{ active: 'baseInfo' == tab }"
                @click="handClickTabs('baseInfo')"
            >
                <a>基本信息</a>
            </div>
            <div
                class="tab-item"
                :class="{ active: 'signProduct' == tab }"
                @click="handClickTabs('signProduct')"
            >
                <a>签约产品</a>
            </div>
        </div>
        <baseInfo v-show="'baseInfo' == tab" @is-submit="handIsSubmit" :covenantId="isSubmitId" :status="status"></baseInfo>
        <signProduct v-show="'signProduct' == tab" @is-submit="handIsSubmit" :covenantId="isSubmitId" :status="status"></signProduct>
    </div>
</template>

<script>
import baseInfo from './baseInfo';
import signProduct from './signProduct';

export default {
    components: {
        baseInfo,
        signProduct
    },
    data() {
        return {
            tab: 'baseInfo',
            tabList: [
                {
                    label: '基本信息',
                    components: 'baseInfo'
                },
                {
                    label: '签约产品',
                    components: 'signProduct'
                }
            ],
            isSubmit: false,
            isSubmitId: null,
            status: null
        };
    },
    created() {
        this.isSubmitId = this.$route.query.rowId;
        if (this.$route.query.is_signProduct == 1) {
            this.tab = 'signProduct';
            this.isSubmit = true;
        }
    },
    methods: {
        handIsSubmit(value, id, status) {
            this.isSubmit = value;
            this.isSubmitId = id;
            this.status = status;
        },

        handClickTabs(name) {
            if (name == 'signProduct' && !this.isSubmit) {
                this.$notice.msg('数据尚未保存');
                this.tab = 'baseInfo';
                return;
            }
            this.tab = name;
        }
    }
};
</script>
<style lang="scss" scoped>
.page-container {
    position: relative;
    /deep/ .ivu-tabs-tab {
        padding-top: 0 !important;
        font-size: 14px;
    }
    /deep/ {
        .ivu-tabs-bar {
            border-bottom: 1px solid #ececec;
        }
        .ivu-tabs-ink-bar {
            display: none;
        }
        .ivu-tabs-tab {
            padding: 9px 0 10px;
            margin-right: 44px;
            font-size: 14px;
            color: #515c6f;
        }
        .ivu-tabs-tab-active {
            position: relative;
            color: #236dff;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: 1px;
                height: 2px;
                width: 100%;
                background-color: #236dff;
            }
        }
    }
    .tab-box {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
        .tab-item {
            margin-right: 40px;
            padding-bottom: 8px;
            a {
                color: #515a61;
            }
            &.active {
                border-bottom: 2px solid #2d8cf0;
                a {
                    color: #2d8cf0;
                }
            }
        }
    }
}
</style>
